import { atom } from 'nanostores';

const $hasMenuOpen = atom(false);
const $isVideoAutoplayable = atom(true);

export { $hasMenuOpen, $isVideoAutoplayable };
